import {
  Box,
  LinkBox,
  LinkOverlay,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import ImageHandler from '../../ImageHandler';
import Link from '../../Link';
import { Text } from '../../Text';

export interface FramedImageProps {
  href?: string;
  actionLabel?: string;
  image: StaticImageDef | React.ReactElement;
  variant?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}

const FramedImage: React.FC<FramedImageProps> = ({
  href,
  actionLabel,
  image,
  variant,
}) => {
  const styles = useMultiStyleConfig('FramedImage', { variant, href });
  const ContainerElement = href ? LinkBox : Box;
  return (
    <ContainerElement sx={styles.container} role="group">
      <ImageHandler image={image} />
      <Box __css={styles.frame} />
      <Box __css={styles.overlay}>
        <Box __css={styles.text}>
          {href ? (
            <LinkOverlay
              as={Link}
              to={href}
              variant="plain"
              color="white"
              _hover={{ color: 'white' }}
              isExternal={isExternalLink(href)}
            >
              {actionLabel}
            </LinkOverlay>
          ) : (
            <Text>{actionLabel}</Text>
          )}
        </Box>
      </Box>
    </ContainerElement>
  );
};

export default FramedImage;
